export const widgetMixins = {
  methods: {
    getYAxes () {
      var axes = []
      if (this.stackedBarChart) {
        if (this.datasets.length > 1 && this.multiYAxis) {
          this.datasets.forEach(function(data) {
            axes.push({
              id: data.yAxisID,
              type: 'linear',
              ticks: {
                beginAtZero: true
              },
              display: false,
              stacked: true
            })
          })
        } else {
          axes.push({
            ticks: {
              beginAtZero: true
            },
            stacked: true
          })
        }
      } else {
        if (this.datasets.length > 1 && this.multiYAxis) {
          this.datasets.forEach(function(data) {
            axes.push({
              id: data.yAxisID,
              type: 'linear',
              ticks: {
                beginAtZero: true
              },
              display: false
            })
          })
        } else {
          axes.push({
            ticks: {
              beginAtZero: true
            }
          })
        }
      }
      return axes
    },
    addDateToLabel () {
      if (this.datasets.length === 2) {
        this.datasets[0].label = this.datasets[0].label+ ' - ' + this.$store.getters.startDate
        this.datasets[1].label = this.datasets[1].label + ' - ' + this.$store.getters.compareStartDate
      }
    }
  }
}
